module.exports = __webpack_public_path__ + "static/media/manage-contracts.4f0a9f3b.svg";